angular.module('workflow')
    .controller('WorkflowPassController', function ($scope, $rootScope, $uibModalInstance, data, Workflow, WorkflowService) {
        this.$onInit = () => {
            this.item = data
            this.form = {
                id: this.item.id
            }
            this.statuses = WorkflowService.statuses()
            this.onStatusChanged(this.item.status)
        }
        this.onStatusChanged = (newStatus) => {
            this.form.status = newStatus
            delete this.form.worker
            if (this.isStatusFinishedOrArchived()) {
                this.users = []
            }
        }
        this.isStatusFinishedOrArchived = () => {
            return WorkflowService.isStatusFinished(this.form.status)
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return Workflow.pass(this.form).$promise
                .then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast("workflow.updated")
                })
        }
    })
